import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { InsightsRoutes, Routes } from '../../../../constants/Routes'
import { ReportLink } from './ReportLink'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  // Location prop from React Router
  location: any
}

@inject('currentCompanyStore')
@observer
export class ReportNavigation extends React.Component<Props, {}> {
  render() {
    const company = this.props.currentCompanyStore!.company!
    return (
      <div className='p-4'>
        <div className='text-muted'>Overview</div>
        <hr />
        <ReportLink
          location={this.props.location}
          name='Summary'
          url={Routes.DASHBOARD_REPORTS(company.id, 'summary')}
        />

        <ReportLink
          location={this.props.location}
          name='Financials'
          url={Routes.DASHBOARD_REPORTS(company.id, 'financials')}
        />

        <ReportLink
          location={this.props.location}
          name='Payment types'
          url={Routes.DASHBOARD_REPORTS(company.id, 'paymentTypes')}
        />

        <ReportLink
          location={this.props.location}
          name='Sales trends'
          url={Routes.DASHBOARD_REPORTS(company.id, 'sales-trends')}
        />

        <ReportLink
          location={this.props.location}
          name='Day of week/hourly'
          url={Routes.DASHBOARD_REPORTS(company.id, 'salesByDayAndHour')}
        />
        <ReportLink
          location={this.props.location}
          name='Gift cards'
          url={Routes.DASHBOARD_REPORTS(company.id, 'giftCards')}
        />
        <br />

        <div className='text-muted'>Sales</div>
        <hr />
        <ReportLink
          location={this.props.location}
          name='Products overview'
          url={Routes.DASHBOARD_REPORTS(company.id, 'productsOverview')}
        />
        <ReportLink
          location={this.props.location}
          name='Products over time'
          url={Routes.DASHBOARD_REPORTS(company.id, 'productsOverTime')}
        />
        <ReportLink
          location={this.props.location}
          name='Categories overview'
          url={Routes.DASHBOARD_REPORTS(company.id, 'categoriesOverview')}
        />
        <ReportLink
          location={this.props.location}
          name='Categories over time'
          url={Routes.DASHBOARD_REPORTS(company.id, 'categoriesOverTime')}
        />
        <ReportLink
          location={this.props.location}
          name='Brands & Vendors'
          url={Routes.DASHBOARD_REPORTS(company.id, 'vendors')}
        />
        <ReportLink
          location={this.props.location}
          name='Sources'
          url={Routes.DASHBOARD_REPORTS(company.id, 'sources')}
        />
        <ReportLink
          location={this.props.location}
          name='Discounts'
          url={Routes.DASHBOARD_REPORTS(company.id, 'discounts')}
        />
        <br />

        <div className='text-muted'>Inventory</div>
        <hr />
        <ReportLink
          location={this.props.location}
          name='Inventory on-hand'
          url={Routes.DASHBOARD_REPORTS(company.id, 'inventory-on-hand')}
        />
        <ReportLink
          location={this.props.location}
          name='Inventory log summary'
          url={Routes.DASHBOARD_REPORTS(company.id, 'inventorySummary')}
        />
        <ReportLink
          location={this.props.location}
          name='Reorder'
          url={Routes.INSIGHTS_REPORTS(company.id, InsightsRoutes.INVENTORY_REORDER)}
        />
        <ReportLink
          location={this.props.location}
          name='Inventory restock'
          url={Routes.DASHBOARD_REPORTS(company.id, 'restock')}
        />
        <ReportLink
          location={this.props.location}
          name='Transfers'
          url={Routes.DASHBOARD_REPORTS(company.id, 'transfers')}
        />
        <ReportLink
          location={this.props.location}
          name='Purchase orders'
          url={Routes.DASHBOARD_REPORTS(company.id, 'purchaseOrders')}
        />
        <br />

        <div className='text-muted'>Customers</div>
        <hr />
        <ReportLink
          location={this.props.location}
          name='Customers'
          url={Routes.DASHBOARD_REPORTS(company.id, 'customers')}
        />
        <br />

        <div className='text-muted'>Employees</div>
        <hr />
        <ReportLink
          location={this.props.location}
          name='Employee sales'
          url={Routes.DASHBOARD_REPORTS(company.id, 'employeeSales')}
        />
        <ReportLink
          location={this.props.location}
          name='Employee hours'
          url={Routes.DASHBOARD_REPORTS(company.id, 'employeeHours')}
        />
        <br />
        <br />
        <br />
      </div>
    )
  }
}
